import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "circle-x, close, checkbox, remove" }, [
      _createElementVNode("path", {
        id: "vector",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1.66675 10.0001C1.66675 5.39771 5.39771 1.66675 10.0001 1.66675C14.6025 1.66675 18.3334 5.39771 18.3334 10.0001C18.3334 14.6025 14.6025 18.3334 10.0001 18.3334C5.39771 18.3334 1.66675 14.6025 1.66675 10.0001ZM7.94202 7.05814C7.69795 6.81406 7.30222 6.81406 7.05814 7.05814C6.81406 7.30222 6.81406 7.69795 7.05814 7.94202L9.1162 10.0001L7.05814 12.0581C6.81406 12.3022 6.81406 12.6979 7.05814 12.942C7.30222 13.1861 7.69795 13.1861 7.94202 12.942L10.0001 10.884L12.0581 12.942C12.3022 13.1861 12.6979 13.1861 12.942 12.942C13.1861 12.6979 13.1861 12.3022 12.942 12.0581L10.884 10.0001L12.942 7.94202C13.1861 7.69795 13.1861 7.30222 12.942 7.05814C12.6979 6.81406 12.3022 6.81406 12.0581 7.05814L10.0001 9.1162L7.94202 7.05814Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }